import PropTypes from 'prop-types';
import React from 'react';
import CreatePostCta from '../create-post-cta';
import ItemContainer from '../post-list-mobile-common/item-container';
import NoPostsFiltered from '../no-posts-filtered';
import { HorizontalSeparator } from '../separator';
import { CategoryPageFiltersBar } from '../filters-bar-mobile';
import PaginationMobile from '../pagination-mobile';
import { POSTS_PER_PAGE } from '../../constants/pagination';
import FollowCard from '../follow-card';
import PostListCard from '../card/post-list-card';

const PostListMobileClassic = ({
  page,
  category,
  posts,
  entityCount,
  query,
  onPageChange,
  buildPageUrl,
  onLikeClick,
  showCreatePostAction,
  showFollowCategoryAction,
  showPinIcon,
  showLockIcon,
  showBestAnswer,
  showMoreButton,
  showViewCount,
  showFilters,
  hasActiveFilter,
  uniquePostTypesInAllCategories,
}) => {
  let postTypes;
  if (showCreatePostAction) {
    postTypes =
      uniquePostTypesInAllCategories.length === 1
        ? uniquePostTypesInAllCategories
        : category.postTypes;
  }
  return (
    <div>
      {showCreatePostAction && (
        <React.Fragment>
          <ItemContainer>
            <CreatePostCta categorySlug={category.slug} postTypes={postTypes} />
          </ItemContainer>
          <HorizontalSeparator />
        </React.Fragment>
      )}
      {showFilters && <CategoryPageFiltersBar />}
      {!posts.length && hasActiveFilter && <NoPostsFiltered />}
      {posts.map((post, idx) => (
        <React.Fragment>
          <ItemContainer key={post._id}>
            <PostListCard
              post={post}
              query={query}
              onLikeClick={onLikeClick}
              showContent={false}
              showPinIcon={showPinIcon}
              showLockIcon={showLockIcon}
              showBestAnswer={showBestAnswer}
              showMoreButton={showMoreButton}
              showViewCount={showViewCount}
              showRecentActivity
            />
          </ItemContainer>
          {idx < posts.length - 1 ? <HorizontalSeparator /> : null}
        </React.Fragment>
      ))}
      <PaginationMobile
        page={page}
        entityCount={entityCount}
        showPerPage={POSTS_PER_PAGE}
        onChange={({ page }) => onPageChange(page)}
        buildPageUrl={buildPageUrl}
      />
      {(showCreatePostAction || showFollowCategoryAction) && <HorizontalSeparator />}
      {showCreatePostAction && (
        <React.Fragment>
          <ItemContainer>
            <CreatePostCta categorySlug={category.slug} postTypes={postTypes} />
          </ItemContainer>
        </React.Fragment>
      )}
      {showFollowCategoryAction && (
        <FollowCard withoutPaddingTop={showCreatePostAction} category={category} />
      )}
    </div>
  );
};

PostListMobileClassic.propTypes = {
  onLikeClick: PropTypes.func.isRequired,
  category: PropTypes.object,
  posts: PropTypes.array,
  location: PropTypes.object,
  query: PropTypes.string,
  showCreatePostAction: PropTypes.bool,
  showFollowCategoryAction: PropTypes.bool,
  showFilters: PropTypes.bool,
  showPinIcon: PropTypes.bool,
  showLockIcon: PropTypes.bool,
  showBestAnswer: PropTypes.bool,
  showMoreButton: PropTypes.bool,
  showViewCount: PropTypes.bool,
  hasActiveFilter: PropTypes.bool,
  uniquePostTypesInAllCategories: PropTypes.array,
  page: PropTypes.number,
  entityCount: PropTypes.number,
  onPageChange: PropTypes.func,
  buildPageUrl: PropTypes.func,
};

PostListMobileClassic.defaultProps = {
  showPinIcon: true,
  showLockIcon: true,
  showBestAnswer: true,
  showMoreButton: true,
  showViewCount: true,
};

export default PostListMobileClassic;
